<template>
  <v-dialog
    v-model="showConfirmationModal"
    max-width="350"
  >
    <v-card>
      <v-card-title class="headline">Подтверждение</v-card-title>
      <v-card-text>
        Вы уверены, что хотите подтвердить?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          flat="flat"
          @click="showConfirmationModal = false"
        >
          Нет
        </v-btn>
        <v-btn
          color="green darken-1"
          flat="flat"
          @click="confirmBalance">
          Да
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BalanceConfirmationModal',
  data () {
    return {
      showConfirmationModal: false
    }
  },
  methods: {
    open () {
      this.showConfirmationModal = true
    },
    confirmBalance () {
      this.showConfirmationModal = false
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>

</style>
